import { styled } from '@porsche-code/kado-styled-system/jsx';
import {
  PSpinner,
  PSpinnerProps,
} from '@porsche-design-system/components-react';

const Wrapper = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'center',
  },
});

const Overlay = styled('div', {
  base: {
    position: 'absolute',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    zIndex: 'default',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const Spinner = (props: PSpinnerProps) => (
  <Wrapper>
    <PSpinner {...props} />
  </Wrapper>
);

export const SpinnerOverlay = (props: PSpinnerProps) => (
  <Overlay>
    <Spinner {...props} />
  </Overlay>
);
